import { render, staticRenderFns } from "./MunchenLevel.vue?vue&type=template&id=3924fe3b&scoped=true&"
import script from "./MunchenLevel.vue?vue&type=script&lang=js&"
export * from "./MunchenLevel.vue?vue&type=script&lang=js&"
import style0 from "./MunchenLevel.vue?vue&type=style&index=0&id=3924fe3b&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3924fe3b",
  null
  
)

export default component.exports